import { render, staticRenderFns } from "./OriginEdit.vue?vue&type=template&id=6915414a&"
import script from "./OriginEdit.vue?vue&type=script&lang=js&"
export * from "./OriginEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports